import { AppCurrency } from "../Balance.types";

export const CURRENCY_UNIT: Record<AppCurrency, string> = {
    cop: "$",
};
